import React from 'react';
import Dropdown from 'react-bootstrap/Dropdown';
import DropdownButton from 'react-bootstrap/DropdownButton';
import CountryModal from './CountryModal';

function Header() {
  const BASE_URL = 'https://www.hearttohomemeals.ca';
  const [modalShow, setModalShow] = React.useState(false);

  const handleKeyDown = (event) => {
    if (event.key === 'Enter') {
        if (event.target.value === '') {
            return;
        }

        let SEARCH_URL = BASE_URL + '/meals?search=';
        window.location.href = SEARCH_URL + event.target.value;
    }
  }

  return (

<header>
    <CountryModal show={modalShow}
        onHide={() => setModalShow(false)}></CountryModal>
    <div className="navbarTop container-fluid">
        <nav className="navbar navbar-expand-lg d-none d-lg-flex header-top-menu">
            <div className="collapse navbar-collapse" id="TopLeftNav">
                <ul className="navbar-nav mr-auto left-nav-bar">
                    <li className="nav-item no-scroll">
                        <a className="nav-link" href={`${BASE_URL}`}>Home</a>
                    </li>
                    <li className="nav-item no-scroll">
                        <a className="nav-link" href={`${BASE_URL}/About/About-Us`}>About</a>
                    </li>
                    <li className="nav-item no-scroll">
                        <a className="nav-link" href={`${BASE_URL}/blog`}>Blog</a>
                    </li>
                    <li className="nav-item no-scroll">
                        <a className="nav-link" href={`${BASE_URL}/help/contact`}>Contact</a>
                    </li>

                </ul>
            </div>
            <div>
                
                <ul className="navbar-nav ml-auto top-right-menu">
                    <li className="nav-item">
                        <a className="nav-link telephone-link" href="tel:1-855-442-6325"><i className="fas fa-phone fa-flip-horizontal mr-2" aria-hidden="true"></i><span className="telephone-number">1-855-442-6325</span></a>
                    </li>
                    <li className="nav-item">
                        <a className="nav-link" href={`${BASE_URL}/help`} ><i className="fa fa-question-circle mr-2" aria-hidden="true"></i>Help</a>
                    </li>
                    <li className="nav-item">
                        <a href={`${BASE_URL}/account/signin/`} className="nav-link" >Sign in</a>
                    </li>
             
                    <li className="nav-item">
                        <a className="nav-link cart-icon" style={{marginRight: 66}}  href={`${BASE_URL}/cart`}>
                            <i className="fas fa-shopping-cart  mr-3 position-relative" aria-hidden="true">
                            </i>
                            Cart
                            <span className="cart-item-value"></span></a>
                    </li>
              
                    <li className="nav-item">
                        <a href="#" onClick={() => setModalShow(true)} className="nav-link flag-link do-not-underline" data-dialog="site-dialog" title="You are on the Canada Heart to Home Meals">
                                  <img src="./img/flag_ca.png" width="32" alt="Canada flag"/>
                        </a>
                    </li>
                

                </ul>
            </div>
        </nav>
    </div>


    <div className="header-body hthm container-fluid d-none d-lg-block">
        <nav className="navbar navbar-expand-lg d-none d-sm-block">
            <div className="row outer-row align-items-end">
                <div className="col-4 col-lg-2 align-bottom">
                    <a className="navbar-brand" href={`${BASE_URL}`} >
                              <img className="logo" src="./img/logo.png" alt="hthm logo" />
                    </a>
                </div>
                <div className="col-8 col-lg-10 text-right print-hidden">
                    <div className="row">
                        <div className="col-12">
                            <div className="row pb-2">
                                <div className="col-12">
                                        &nbsp;
                                </div>
                            </div>


                            <a href={`${BASE_URL}/help/how-our-service-works`}>How Our Service Works</a>
                            <a href={`${BASE_URL}/home/request-a-brochure`} className="btn btnApetito blue ml-2 mb-2 pt-2">Request a Menu</a><br />

                        </div>
                    </div>
                    <div className="row">
                        <div className="col-lg-9 col-xl-7">
                            <div className="collapse navbar-collapse" id="headerNav">
                                <ul className="navbar-nav mr-auto">
                                    
                                    <li className="nav-item">
                                        <a className="nav-link" href={`${BASE_URL}/meals?collection=LunchDinner`}>Lunch &amp; Dinner</a>
                                    </li>
                                    <li className="nav-item">
                                        <a className="nav-link" href={`${BASE_URL}/meals?collection=Breakfast`}>Breakfast</a>
                                    </li>
                                    <li className="nav-item">
                                        <a className="nav-link" href={`${BASE_URL}/meals?collection=Soup`}>Soup</a>
                                    </li>
                                    <li className="nav-item">
                                        <a className="nav-link" href={`${BASE_URL}/meals?collection=Dessert`}>Dessert</a>
                                    </li>
                                    <li className="nav-item">
                                        <a className="nav-link" href={`${BASE_URL}/help/special-diets`}>Special Diets</a>
                                    </li>
                                </ul>

                            </div>
                        </div>

                        <div className="col-lg-3 col-xl-5">
                                <input type="text" onKeyDown={handleKeyDown} placeholder="Search for a meal or menu ID" id="search" className="text-center full-round search-box" aria-label="Search box to find a meal" data-placeholder-long="Search for a meal or menu ID" data-placeholder-short="Search" />
                        </div>


                    </div>
                </div>
            </div>
        </nav>
    </div>

    <div className="container-fluid mobile-header d-block d-lg-none pb-2">
        <div className="row">
            <div className="col-6 ">
                <a className="navbar-brand" href={`${BASE_URL}`}>
                    <img src="img/logo.png" className="logo" alt="hthm logo" />
                </a>
            </div>
            <div className="col-6">
                <div className="row">
                    <ul className="mobile-flags">
                                    <li className="nav-item">
                <a href="#" onClick={() => setModalShow(true)} className="nav-link flag-link do-not-underline" data-dialog="site-dialog" title="You are on the Canada Heart to Home Meals">
                    <img src="img/flag_ca.png" width="32" alt="Canada flag" />
                </a>
            </li>



                    </ul>
                </div>
                <div className="row mt-2">
                    <a href={`${BASE_URL}/account/my-account`} className="col my-account">My Account <i className="fas fa-user" aria-hidden="true"></i></a>
                </div>
                <div className="row">
                    <a href={`${BASE_URL}/cart`} className="col cart">Cart<span className="cart-item-value d-inline"> ($0.00)</span> <i className="fas fa-shopping-cart" aria-hidden="true"></i></a>
                </div>
            </div>
        </div>
    </div>
    <ul className="nav mobile-header-nav d-lg-none nav-justified">
        <li className="nav-item dropdown col">
            <DropdownButton variant="danger" className="nav-link " id="dropdown-basic-button" title="Meals">
              <Dropdown.Item href={`${BASE_URL}/meals?collection=LunchDinner`}>Lunch &amp; Dinner</Dropdown.Item>
              <Dropdown.Item href={`${BASE_URL}/meals?collection=Breakfast`}>Breakfast</Dropdown.Item>
              <Dropdown.Item href={`${BASE_URL}/meals?collection=Soup`}>Soup</Dropdown.Item>
              <Dropdown.Item href={`${BASE_URL}/meals?collection=Dessert`}>Dessert</Dropdown.Item>
              <Dropdown.Item href={`${BASE_URL}/help/special-diets`}>Special Diets</Dropdown.Item>
            </DropdownButton>
        </li>

        <li className="nav-item col">
            <a className="nav-link nav-link-spaced" href={`${BASE_URL}/about/about-us`} >About</a>
        </li>
        <li className="nav-item col">
            <div className="nav-link nav-link-spaced">
                <a href={`${BASE_URL}/help`} >Help</a> 
                <i className="ml-1 fa fa-question-circle" aria-hidden="true"></i>
            </div>
        </li>
    </ul>
        <div className="modal fade site-dialog" tabIndex="-1" role="dialog" aria-hidden="true">
        <div className="modal-dialog modal-dialog-centered" role="document">
            <div className="modal-content">
                <div className="modal-header">
                    <h5 className="modal-title">Choose your Heart To Home Meals website</h5>
                    <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">×</span>
                    </button>
                </div>
                <div className="modal-body">
                    <div className="container-fluid">
                        <div className="row p-2">
                            <div className="col-8 offset-2 align-middle">
                                <img src="img/flag_ca.png" alt="Canada flag" width="32" />
                                <a className="ml-2" href={`${BASE_URL}?remembersite=true`} >Canada</a>
                            </div>
                        </div>
                        <div className="row p-2">
                            <div className="col-8 offset-2 align-middle">
                                <img src="img/flag_us" alt="USA flag" width="32" />
                                <a className="ml-2" href="https://hearttohomemeals.com?remembersite=true">United States</a>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="modal-footer">
                    <button type="button" className="btn btn-secondary" data-dismiss="modal">Cancel</button>
                </div>
            </div>
        </div>
    </div>

</header>

  )
}

export default Header;
